export default {
  checkout: {
    seo: {
      cartTitle: 'Sacola de Interesse | AQUAMARINA TOURS',
      cartDescription: 'Sua sacola de interesse de passeios em Paraty. Adicione passeios de escuna, lancha e jeep à sua lista e reserve pelo WhatsApp.',
    },
    cart: {
      item: 'item',
      items: 'itens',
      clear: 'Esvaziar sacola',
      tourDate: 'Data do passeio:',
      review: 'Revise os passeios selecionados e confirme sua reserva com pagamento seguro.',
      deposit: 'Sinal via PIX',
      remaining: 'Restante no dia do passeio',
      depositNote: 'O sinal corresponde a {{percent}}% do total, com mínimo de R$ 20,00.',
      full: 'Pagamento total via PIX',
      fullNote: 'O valor total é pago agora para garantir a reserva.',
      continuePayment: 'Continuar para pagamento',
      clearConfirmTitle: 'Esvaziar sacola?',
      clearConfirmText: 'Todos os itens serão removidos. Esta ação não pode ser desfeita.',
      cancel: 'Cancelar',
      clearConfirm: 'Esvaziar',
    },
    modal: {
      titlePix: 'Pague o sinal com Pix',
      titleDetails: 'Dados do responsável',
      close: 'Fechar',
      adults_one: '{{count}} adulto(s)',
      adults_other: '{{count}} adulto(s)',
      children_one: '{{count}} criança(s)',
      children_other: '{{count}} criança(s)',
      babies_one: '{{count}} bebê(s)',
      babies_other: '{{count}} bebê(s)',
      participants_one: '{{count}} participante(s)',
      participants_other: '{{count}} participante(s)',
      depositLabel: 'Sinal via Pix ({{percent}}%)',
      remainingNote: 'O restante ({{amount}}) é pago no dia do passeio.',
      qrAlt: 'QR code Pix',
      scanHint: 'Escaneie o QR code no app do seu banco ou use o Pix copia e cola.',
      copied: 'Código copiado!',
      copyPix: 'Copiar código Pix',
      waiting: 'Aguardando pagamento — a confirmação aparece aqui automaticamente.',
      fillIn: 'Preencha os dados de quem vai reservar.',
      fullName: 'Nome completo',
      fullNamePlaceholder: 'Nome e sobrenome',
      whatsapp: 'WhatsApp',
      ticketEmailHint: 'Seu ticket chega neste email assim que a reserva for confirmada.',
      pickupLabel: 'Onde buscamos você',
      pickupPlaceholder: 'Hotel, pousada ou endereço em Paraty',
      pickupAgency: 'Embarcar na agência',
      pickupHint: 'Busca grátis das 10:20 às 11:00 no centro de Paraty (até 3 km da agência). O guia confirma o horário pelo WhatsApp.',
      pickupAgencyHint: 'Você embarca na agência: o horário de chegada vem no seu ticket.',
      email: 'Email',
      emailPlaceholder: 'voce@exemplo.com',
      cpf: 'CPF',
      requiredOnline: '(obrigatório para pagar online)',
      talkWhatsApp: 'Falar com a equipe pelo WhatsApp',
      generatingPix: 'Gerando Pix…',
      payPix: 'Pagar sinal de {{amount}} com Pix',
      sendWhatsApp: 'Enviar reserva pelo WhatsApp',
      openingMp: 'Abrindo Mercado Pago…',
      payCard: 'Prefiro pagar com cartão (Mercado Pago)',
      secure: 'Pagamentos processados com segurança pelo Mercado Pago',
      errors: {
        fullName: 'Informe nome e sobrenome.',
        whatsapp: 'Informe um WhatsApp com DDD.',
        email: 'Informe um email válido.',
        cpf: 'CPF inválido.',
        pickup: 'Diga onde buscamos você ou escolha embarcar na agência.',
        offline: 'O pagamento online só funciona no site publicado (ou com "npx netlify dev"). Você pode enviar a reserva pelo WhatsApp.',
        generic: 'Não foi possível concluir a operação.',
        pixFailed: 'Não foi possível gerar o Pix.',
        paymentFailed: 'Não foi possível iniciar o pagamento.',
      },
    },
    flow: {
      steps: { cart: 'Carrinho', holder: 'Responsável', payment: 'Pagamento', confirm: 'Confirmação' },
      stepOf: 'Etapa {{current}} de {{total}}',
      titles: {
        payment: 'Como você prefere pagar?',
        approved: 'Pagamento aprovado',
        inProcess: 'Pagamento em análise',
        rejected: 'Pagamento não aprovado',
      },
      summary: {
        title: 'Resumo da reserva',
        show: 'Ver resumo',
        hide: 'Ocultar resumo',
        total: 'Total',
        dueNow: 'Sinal cobrado agora ({{percent}}%)',
        dueNowPlain: 'Sinal cobrado agora',
        fullNow: 'Pagamento total cobrado agora',
        dueNowShort: 'Sinal agora',
        dueOnDay: 'Restante no dia do passeio',
        date: 'Data',
        guests: 'Participantes',
        empty: 'Sua sacola está vazia.',
      },
      document: {
        legend: 'Documento',
        cpf: 'CPF',
        passport: 'Passaporte',
        cpfHint: 'Digite só os números; a formatação é automática.',
        passportNumber: 'Número do passaporte',
        passportPlaceholder: 'Ex.: AB1234567',
        passportHint: 'Para visitantes estrangeiros.',
        nationality: 'País do passaporte',
        nationalityPlaceholder: 'Selecione o país',
        frequent: 'Mais comuns',
        allCountries: 'Todos os países',
      },
      errors: {
        passport: 'Informe o número do passaporte (5 a 20 letras ou números).',
        nationality: 'Selecione o país do passaporte.',
        pixNeedsCpf: 'O Mercado Pago exigiu CPF para este Pix. Informe um CPF ou confirme sua reserva pelo WhatsApp.',
        cardSdk: 'Não foi possível carregar o formulário seguro do cartão. Verifique sua conexão e tente de novo, ou pague pelo checkout do Mercado Pago.',
      },
      actions: {
        continue: 'Continuar para o pagamento',
        back: 'Voltar',
        editDetails: 'Editar',
        whatsappInstead: 'Prefiro enviar a reserva pelo WhatsApp',
        retry: 'Tentar novamente',
        tryAnotherCard: 'Tentar com outro cartão',
        payWithPix: 'Pagar com Pix',
        payWithCard: 'Pagar com cartão de crédito',
        newPix: 'Gerar novo Pix',
        showPix: 'Ver o QR code do Pix',
        viewReservation: 'Ver minha reserva',
        otherMethod: 'Outra forma de pagamento',
      },
      whatsappNote: 'Para enviar pelo WhatsApp bastam nome e WhatsApp.',
      tabs: { label: 'Forma de pagamento', pix: 'Pix', card: 'Cartão de crédito' },
      pix: {
        instant: 'Confirmação na hora',
        validity: 'QR code válido por 30 minutos',
        anyBank: 'Funciona no app de qualquer banco',
        passportNote: 'Com passaporte, alguns bancos e contas exigem CPF no Pix. Se não funcionar, confirme sua reserva pelo WhatsApp.',
        expiresIn: 'Expira em {{time}}',
        expired: 'Este Pix expirou. Gere um novo código para pagar.',
        paste: 'Pix copia e cola',
      },
      card: {
        lead: 'Sinal de {{amount}} em até 3x. Os dados do cartão vão direto para o Mercado Pago, sem passar pelo nosso site.',
        loading: 'Carregando formulário seguro…',
        processing: 'Processando o pagamento…',
        fallbackNote: 'Você será levado ao checkout seguro do Mercado Pago para pagar com cartão (até 3x) e voltará ao site no final.',
        fallbackButton: 'Pagar {{amount}} com cartão no Mercado Pago',
      },
      result: {
        approvedDesc: 'Seu sinal foi pago e a reserva está confirmada. Abrindo sua confirmação…',
        inProcessDesc: 'O Mercado Pago está analisando o pagamento. Você recebe a resposta por email, normalmente em poucos minutos.',
        rejectedDesc: 'Nenhum valor foi cobrado. Você pode tentar com outro cartão ou pagar com Pix.',
        paymentId: 'Pagamento nº {{id}}',
      },
      statusDetail: {
        accredited: 'Pagamento aprovado.',
        pending_contingency: 'Estamos processando o pagamento. Em até 2 dias úteis você recebe o resultado por email.',
        pending_review_manual: 'O pagamento está em revisão. Em até 2 dias úteis você recebe o resultado por email.',
        cc_rejected_bad_filled_card_number: 'Confira o número do cartão.',
        cc_rejected_bad_filled_date: 'Confira a data de validade do cartão.',
        cc_rejected_bad_filled_other: 'Confira os dados do cartão.',
        cc_rejected_bad_filled_security_code: 'Confira o código de segurança (CVV) do cartão.',
        cc_rejected_blacklist: 'Não foi possível processar o pagamento com este cartão. Use outro cartão ou Pix.',
        cc_rejected_call_for_authorize: 'Seu banco pede autorização para este pagamento. Ligue para o banco e tente de novo.',
        cc_rejected_card_disabled: 'Este cartão não está ativo. Ligue para o banco para ativá-lo ou use outro cartão.',
        cc_rejected_card_error: 'Não foi possível processar o pagamento. Tente novamente ou use outro cartão.',
        cc_rejected_duplicated_payment: 'Você já fez um pagamento com este valor. Se precisa pagar de novo, use outro cartão ou Pix.',
        cc_rejected_high_risk: 'O pagamento foi recusado por segurança. Use outro cartão ou pague com Pix.',
        cc_rejected_insufficient_amount: 'O cartão não tem limite suficiente. Use outro cartão ou Pix.',
        cc_rejected_invalid_installments: 'Este cartão não aceita o número de parcelas escolhido. Tente à vista ou outro cartão.',
        cc_rejected_max_attempts: 'Você atingiu o limite de tentativas. Use outro cartão ou Pix.',
        cc_rejected_other_reason: 'O banco não aprovou o pagamento. Use outro cartão ou Pix.',
        default: 'O pagamento não foi aprovado. Use outro cartão ou pague com Pix.',
      },
    },
    paymentReturn: {
      loadingTitle: 'Verificando seu pagamento…',
      approvedTitle: 'Pagamento aprovado',
      pendingTitle: 'Pagamento pendente',
      failedTitle: 'Pagamento não concluído',
      loadingDesc: 'Estamos confirmando o resultado com o Mercado Pago.',
      approvedDesc: 'Sua reserva está confirmada. Envie a confirmação pelo WhatsApp para a equipe já separar suas vagas.',
      pendingDesc: 'O Mercado Pago ainda está processando o pagamento. Assim que for aprovado, sua reserva será confirmada.',
      failedDesc: 'Nenhuma cobrança foi confirmada. Você pode tentar novamente ou falar com a equipe pelo WhatsApp.',
      emailSent: 'Enviamos seu ticket em PDF para o email informado.',
      emailFailed: 'A reserva foi confirmada, mas não conseguimos enviar o email. Você pode abrir o ticket abaixo.',
      sendConfirmation: 'Enviar confirmação pelo WhatsApp',
      talkTeam: 'Falar com a equipe pelo WhatsApp',
      viewTicket: 'Ver meu ticket',
      backToCart: 'Voltar para a sacola',
      confirmedTitle: 'Reserva confirmada!',
      thanks: 'Obrigado, {{name}}! Sua vaga em {{tour}} está garantida. Nos vemos a bordo.',
      ticketByEmail: 'Seu ticket chega no seu email {{email}}, e você também pode baixá-lo em PDF.',
      summaryDate: 'Data',
      summaryPeople: 'Pessoas',
      summaryPaid: 'Sinal pago',
      summaryRemaining: 'Restante no dia',
      ticketHeadline: 'RESERVA CONFIRMADA',
      ticketDate: 'Data',
      ticketPeople: 'Pessoas',
      ticketCode: 'Código',
      ticketPaid: 'PIX ✓ PAGO',
    },
    ticket: {
      notFound: 'Ticket não encontrado',
      backToSite: 'Voltar ao site',
      title: 'Ticket de reserva',
      holder: 'RESPONSÁVEL',
      whatsapp: 'WhatsApp: {{phone}}',
      confirmed: 'CONFIRMADA',
      participants_one: '{{count}} participante(s)',
      participants_other: '{{count}} participante(s)',
      total: 'Total',
      depositPaid: 'Sinal pago',
      downloadPdf: 'Baixar PDF',
      addWallet: 'Adicionar à Wallet',
      walletAlert: 'A Wallet requer configurar o Apple Wallet ou o Google Wallet como emissor.',
    },
  },
};
